import { ProductParser } from "@/models/admin/product/product.parser"
import { IProduct } from "@/models/admin/product/product.types"
import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"

class ProductServiceClass {
  getProductList() {
    return useQuery({
      ...HasuraQueries.product.list(),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (rawData) =>
        (rawData?.product_view?.map((rawProduct) =>
          ProductParser.toDomain(rawProduct),
        ) as IProduct[]) ?? [],
    })
  }
}

export const ProductService = new ProductServiceClass()
